export default "__VITE_ASSET__2a28f21b__"